<div class="visibility-container">
  <div class="content">
    <div class="title">{{ title }}</div>
    <div class="sub-title">{{ subtitle }}</div>
  </div>
  <u-toggle-switch
    class="toggle-switch"
    type="small"
    (onChange)="onToggle($event)"
    [disabled]="disabled || isViewer"
    [checked]="checked"
  ></u-toggle-switch>
</div>
